export function isNumericIndexedObject(obj, valueGuard) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    const rec = obj;
    for (const key in rec) {
        if (!/^\d+$/.test(key)) {
            return false;
        }
        const value = rec[key];
        if (!valueGuard(value)) {
            return false;
        }
    }
    return true;
}
